import { Record } from 'immutable';
export default Record({
  thumbnailUrl: null,
  deckId: null,
  numViews: null,
  folderId: null,
  user: null,
  title: null,
  meanDuration: null,
  numShares: null,
  createdAt: null,
  numUniqueVisitors: null,
  progressionPercent: null,
  slides: null,
  userId: null,
  brandId: 0,
  updatedAt: null
}, 'DocumentMetadataRecord');